import { render } from "./StockTransferEditView.vue?vue&type=template&id=2ef72b28&scoped=true"
import script from "./StockTransferEditView.vue?vue&type=script&lang=js"
export * from "./StockTransferEditView.vue?vue&type=script&lang=js"

import "./StockTransferEditView.vue?vue&type=style&index=0&id=2ef72b28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef72b28"]])

export default __exports__